import React from 'react';
import { remCalc } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { Box, Fade, Grid, GridSize } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { GuessStates, GuessImgSrcMap } from 'types';

const t = (key: string) => translate('activities', key);
interface Props {
  guessIndicator: string;
  SceneComponent: React.ReactChild;
  tileComponents: any[];
}

const GWhereRoundLayout: React.FC<Props> = ({ guessIndicator, SceneComponent, tileComponents }) => {
  const gridItemLength = (12 / tileComponents.length || 1) as GridSize;
  const classes = styles();

  return (
    <Box className={classes.container}>
      <Box style={{ height: '100%', width: '100%', position: 'relative' }}>
        {SceneComponent}
        <Fade in={guessIndicator !== GuessStates.NULL}>
          <img
            alt={t('feedbackImg')}
            className={classes.feedbackImg}
            src={GuessImgSrcMap[guessIndicator]}
          />
        </Fade>
      </Box>

      <Grid container spacing={6} style={{ marginTop: remCalc(10) }}>
        {tileComponents.map((TileComponent, index) => (
          <Grid key={index} item xs={gridItemLength}>
            <Box style={{ height: remCalc(185) }}>
              <TileComponent />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

const styles = makeStyles(() => ({
  container: {
    height: '100%',
    maxWidth: remCalc(1200),
    margin: 'auto',
    padding: '0.5rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  feedbackImg: {
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    position: 'absolute',
  },
}));

export default GWhereRoundLayout;
